import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class BillingAccountMultiSelectListComponent implements IController {

  billingAccountId: any;
  selectedIds: string[];
  branchIds: string[];
  depotIds: string[];
  disabledIds: string[];
  isShowBranchFilter: boolean;
  ngPlaceholder: any;

  onChange: Function;

  private billingAccountsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: string;
  private selectedKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $billingAccounts, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.billingAccountsRef = this.$billingAccounts();
    this.loadLimit = 20;
    this.branchIds = !_.isUndefined(this.branchIds) ? this.branchIds : [];

    if (!this.selectedIds) {
      this.selectedIds = []
    }
    this.billingAccountsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.billingAccountsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  onToggle(accountId, isSelected) {
    this.onChange({
      accountIds: isSelected ? _.concat(this.selectedIds || [], [accountId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== accountId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({accountIds: []});
    } else {
      this.onChange({accountIds: this.infiniteScroll?.getItems()?.map((account) => account.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(account => account.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.billingAccountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      isDemand: true,
      branchIds: this.branchIds,
      sort: 'name,asc'
    };
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountMultiSelectList', {
    bindings: {
      selectedIds: '<',
      branchIds: '<?',
      disabledIds: '<?',
      isShowBranchFilter: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./billing-account-multi-select-list.html').default,
    controller: BillingAccountMultiSelectListComponent
  });
